'use client';

import { usePathname } from 'next/navigation';
import { type ReactNode, useEffect } from 'react';
import { useUser } from '@/app_lib/providers/UserProvider';

const ARTICLE_PATH_PATTERN = /^\/\d{4}\/\d{2}\/\d{2}\//;

function useIsMobileAppArticle(): boolean {
  const { isMobileApp } = useUser();
  const pathname = usePathname() ?? '';
  return isMobileApp && ARTICLE_PATH_PATTERN.test(pathname);
}

export const HideOnMobileAppArticle = ({ children }: { children: ReactNode }) => {
  const isMobileAppArticle = useIsMobileAppArticle();
  if (isMobileAppArticle) {
    return null;
  }
  return children;
};
